// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2023 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

//订单过滤器

/**
 * @description 支付状态
 */
export function paidFilter(status) {
  var statusMap = {
    true: '已支付',
    false: '未支付'
  };
  return statusMap[status];
}

/**
 * @description 订单状态
 * 2,已收货，待评价
 */
export function orderStatusFilter(status) {
  var statusMap = {
    0: '待支付',
    1: '待发货',
    2: '部分发货',
    3: '待核销',
    4: '待收货',
    5: '已收货',
    6: '已完成',
    9: '已取消'
  };
  return statusMap[status];
}
/**
 * @description 订单状态
 * 2,已收货，待评价         
 */
export function orderRefundStatus(status) {
  var statusMap = {
    0: '未退款',
    1: '申请中',
    2: '部分退款',
    3: '已退款'
  };
  return statusMap[status];
}

/**
 * @description 订单中的退款状态
 * 2,已收货，待评价
 */
export function orderRefundStatusFilter(status) {
  var statusMap = {
    0: '未退款',
    1: '申请退款中',
    2: '部分退款',
    3: '已退款'
  };
  return statusMap[status];
}

/**
 * @description 退款状态
 * 2,已收货，待评价    :0:待审核 1:商家拒绝 2:退款中 3:已退款 4:用户退货 5:商家待收货 6:已撒销"
 */
export function refundStatusFilter(status) {
  var statusMap = {
    0: '待审核',
    1: '拒绝退款',
    2: '退款中',
    3: '已退款',
    4: '用户退货',
    5: '商家待收货',
    6: '已撒销'
  };
  return statusMap[status];
}

/** 实际支付方式，兼容历史订单。 */
export function payMethodFilter(payType, payMethod, paid) {
  var method = String(payMethod || '').trim();
  var methods = {
    alipay: '支付宝',
    wechatpay: '微信',
    weixin: '微信',
    quickpay: '银行卡',
    manualpay: '扫码转账',
    balance: '余额',
    coupon: '优惠券',
    cup_yunshanfu: '银联云闪付'
  };
  if (method) {
    var normalized = method.toLowerCase();
    if (methods[normalized]) return methods[normalized];
    if (/^ALIPAY_/i.test(method)) return '支付宝';
    if (/^WECHAT_/i.test(method)) return '微信';
    if (/^(EBANK_|AGRT_|BANK_CARD_)/i.test(method)) return '银行卡';
    // 连连等历史订单保存的是中文方式名称，保留原始信息。
    if (/[\u4e00-\u9fff]/.test(method)) return method;
    return '未知';
  }
  var directMethods = {
    alipay: '支付宝',
    weixin: '微信',
    yue: '余额',
    wallet: '积分',
    confirmPay: '后台确认',
    ybalipay: '支付宝',
    ybweixin: '微信',
    ybQuickPay: '银行卡',
    jdAlipay: '支付宝',
    jdQuickPay: '银行卡',
    ylAlipay: '支付宝',
    ylQuickPay: '银行卡'
  };
  return directMethods[payType] || (paid === true || paid === 1 || paid === '1' ? '未知' : '未选择');
}

/**
 * @description 支付方式
 */
export function payTypeFilter(status, payMethod) {
  if (status === 'jushuPay') {
    var methods = {
      aliPay: '支付宝',
      wechatPay: '微信',
      quickPay: '银行卡',
      manualPay: '扫码转账'
    };
    return methods[payMethod] || '统一收银台';
  }
  var statusMap = {
    weixin: '微信',
    alipay: '支付宝',
    yue: '余额',
    confirmPay: '后台确认',
    wallet: '积分',
    lianlian: '连连',
    kq: '快钱',
    yop: '易宝',
    ybalipay: '支付宝',
    jdAlipay: '京东',
    jdQuickPay: '京东',
    ylAlipay: '银联',
    ylQuickPay: '银联'
  };
  return statusMap[status];
}